import styled from 'styled-components'
import { fontSizes } from 'src/resources/typography'
import { Colors } from 'src/resources/colors'

const HeaderWrap = styled.div`
  font-size: ${fontSizes.type24};
  font-weight: 600;
  color: ${Colors.textLogo};
  p {
    font-size: ${fontSizes.type14};
    font-weight: 400;
    line-height: 24px;
    max-width: 433px;
    margin: 1rem auto;
  }

  text-align: center;
  margin: 28px 0;
`

interface IOverlayHeader {
  title: string | JSX.Element
  description?: string
}

export function OverlayHeader({ title, description }: IOverlayHeader) {
  return (
    <HeaderWrap>
      {title}
      {description && <p>{description}</p>}
    </HeaderWrap>
  )
}
